// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-admin-cache',
    data: () => ({
        cache: [],
        isLoading: false
    }),
    created() {
        this.loadCache();
    },
    beforeMount() {
        this.$appHost.eventBus.on('refresh', this.loadCache);
    },
    beforeUnmount() {
        this.$appHost.eventBus.off('refresh', this.loadCache);
    },
    methods: {
        loadCache() {
            //set
            this.isLoading = true;
            appHost.api.get(`admin/cache`).then((e) => {
                //Product
                this.cache = e.data;
                //Loading
                this.isLoading = false;
            }).catch(e => {
                this.isLoading = false;
                appHost.notification.showToast(utils.getAxiosErrorMessage(e), "error");
            });
        },
        deleteCache(event, item) {
            //Item
            event.preventDefault();
            //Run
            appHost.api.delete(`admin/cache/clear/${encodeURIComponent(item.name)}`).then((e) => {
                this.cache.splice(this.cache.indexOf(item), 1);
            }).catch(e => {
                appHost.notification.showToast(utils.getAxiosErrorMessage(e), "error");
            });
        },
    }
});
// #endregion
